/**
 * This module was automatically generated by `ts-interface-builder`
 */
import * as t from "ts-interface-checker";
// tslint:disable:object-literal-key-quotes

export const ImportFromGristTableMapping = t.iface([], {
  "sourceTableId": "string",
  "destTableId": t.opt("string"),
  "structureOnly": t.opt("boolean"),
});

export const ImportFromGristPost = t.iface([], {
  "sourceDocId": "string",
  "tables": t.array("ImportFromGristTableMapping"),
  "replaceExistingTables": t.opt("boolean"),
});

export const ImportFromGristResult = t.iface([], {
  "tables": t.array(t.iface([], {
    "sourceTableId": "string",
    "tableId": "string",
  })),
  "warnings": t.array("string"),
});

export const GristImportAPI = t.iface([], {
  "importFromGrist": t.func("ImportFromGristResult", t.param("params", "ImportFromGristPost")),
});

const exportedTypeSuite: t.ITypeSuite = {
  ImportFromGristTableMapping,
  ImportFromGristPost,
  ImportFromGristResult,
  GristImportAPI,
};
export default exportedTypeSuite;
